import { configureStore } from "@reduxjs/toolkit";
import currentReducer from "./features/currentSlice";
import cacheReducer from "./features/cacheSlice";

export const store = configureStore({
  reducer: {
    current: currentReducer,
    cache: cacheReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
